module.exports = __webpack_public_path__ + "static/img/przybornik_wyroznij.af1b6883.png";